import React, { Fragment } from "react";
import { noop } from "lodash";

import WelcomeHeaderRegistration from "../../_molecule/WelcomeHeaderRegistration";
import HeaderRegistration from "../../_organism/HeaderRegistration";

import {
  OuterContainer,
  InnerContainer,
  PromoWrapper,
  InnerSpacingContainer,
  InnerTitleWrapper,
  InnerTitleNote,
  InnerTitle,
  InnerInfo,
  Background,
  ImageRain,
  ListRow,
  RowText
} from "./styled-components";
import rmaBackground from "../../_static/images/rma-blue-texture.png";
import MessageBox from "../../_molecule/MessageBox";
import Icon from "../../_static/Icons";
import { lock } from "../../_static/Icons/iconsDuotone";
import buildColor from "../../_static/ColorPalette";
import RegistrationBodyMask from "../../_static/Masks/registrationBody";

const WelcomePromo = ({
  hasInvalidPromo,
  handleTermsAndDetails,
  notFoundPromoText
}) => (
  <Fragment>
    {hasInvalidPromo && (
      <PromoWrapper>
        <MessageBox
          type="promosInvalid"
          hasIcon
          hasEdit
          editHandleClick={handleTermsAndDetails}
          title={notFoundPromoText}
        />
      </PromoWrapper>
    )}
  </Fragment>
);

const WelcomeRegistrationTemplate = (props) => {
  const {
    children,
    device,
    isLoading,
    brand,
    redirectText,
    headerTitle,
    headerDescription,
    infoText,
    innerTitle,
    promoCTAText,
    notFoundPromoText,
    hasPromo,
    hasInvalidPromo,
    handleTermsAndDetails,
    handleClickAwayGtm,
    bottomInfo,
    welcomeHeaderTitleRef,
    isWelcomeHeaderCollapsed
  } = props;

  return (
    <OuterContainer device={device}>
      <Background>
        <ImageRain src={rmaBackground} alt="registration background" />
      </Background>
      <HeaderRegistration
        device={device}
        brand={brand}
        redirectText={redirectText}
        isWelcomePage
        handleClickAwayGtm={handleClickAwayGtm}
        isWelcomeHeaderCollapsed={isWelcomeHeaderCollapsed}
      />
      <WelcomeHeaderRegistration
        device={device}
        title={headerTitle}
        description={headerDescription}
        isLoading={isLoading}
        handleTermsAndDetails={handleTermsAndDetails}
        hasPromo={hasPromo}
        welcomeHeaderTitleRef={welcomeHeaderTitleRef}
        promoCTAText={promoCTAText}
      />
      <WelcomePromo
        hasInvalidPromo={hasInvalidPromo}
        handleTermsAndDetails={handleTermsAndDetails}
        notFoundPromoText={notFoundPromoText}
      />
      <InnerContainer
        device={device}
        hasPromo={hasPromo}
        hasInvalidPromo={hasInvalidPromo}
      >
        {isLoading ? (
          <RegistrationBodyMask />
        ) : (
          <Fragment>
            <Fragment>
              <InnerTitleWrapper>
                <InnerTitle data-qa-label="welcome-inner-title">
                  {innerTitle}
                </InnerTitle>
                <InnerTitleNote>
                  <Icon
                    icon={lock}
                    viewBoxSize={16}
                    color={buildColor("grey", "200")}
                  />
                  2048-bit encryption
                </InnerTitleNote>
              </InnerTitleWrapper>
              <InnerInfo
                device={device}
                data-qa-label="welcome-inner-info-mobile"
              >
                {infoText}
              </InnerInfo>
            </Fragment>
            <InnerSpacingContainer>
              {children}

              <ListRow>
                <Icon
                  icon={lock}
                  viewBoxSize={16}
                  color={buildColor("grey", "200")}
                />
                <RowText>{bottomInfo}</RowText>
              </ListRow>
            </InnerSpacingContainer>
          </Fragment>
        )}
      </InnerContainer>
    </OuterContainer>
  );
};

WelcomeRegistrationTemplate.defaultProps = {
  device: "mobile",
  isLoading: true,
  brand: "tvg",
  redirectText: "",
  headerTitle: "",
  headerDescription: "",
  innerTitle: "",
  infoText: "",
  promoCTAText: "",
  notFoundPromoText: "",
  hasPromo: false,
  promocode: {
    code: "",
    description: "",
    promoReference: ""
  },
  handleTermsAndDetails: noop,
  handleClickAwayGtm: noop,
  bottomInfo: "",
  isWelcomeHeaderCollapsed: false
};

export default WelcomeRegistrationTemplate;
